/**
 * Created by jax.luo on 2017/1/11.
 */
angular.module('dpw.components')
    .component('dpwSticky', {
        controller: ['$element', function (element) {
            this.$onInit = function () {
                $(element).sticky();
            };
        }]
    });